export enum UsersActionsModels {
  USERS_LOAD = '@USERS/LOAD',
}

export enum UserActionsModels {
  USER_ADD = '@USER/ADD',
  USER_DELETE = '@USER/DELETE',
  USER_UPDATE = '@USER/UPDATE',
  USER_EDIT = '@USER/EDIT',
  DEFAULT = 'DEFAULT'
}
